import dashboardService from '@/services/dashboard.service';
import { useQuery } from '@tanstack/react-query';

export function useDashboardAnalytics() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['dashboard-analytics'],
    queryFn: () => dashboardService.getDashboardAnalytics(),
    staleTime: 2 * 60 * 1000, // 2 minutes
    placeholderData: (previousData) => previousData, // Smooth pagination
  });

  return { data, isLoading, error, refetch };
}
